/*
 * 预付款提醒相关接口
 */
import request from '@/service/request'

export default class warningService {
  /**
   * 检查预付款金额是否需要提醒
   * @returns
   */
  static checkAmount(): Promise<any> {
    return request.post('/station/warning/checkAmount')
  }
}
